var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Media"},[_c('div',{staticStyle:{"height":"500px","background":"olive"}}),_c('vwow')],1)}
var staticRenderFns = []

export { render, staticRenderFns }